<!--<div id="error-404" class="flex-column-center-center">-->

<!--<div class="content" class="flex-column-center-center">-->

<!--<div class="error-code">404</div>-->

<!--<div class="message">Sorry but we could not find the page you are looking for</div>-->

<!--<div class="search" class="flex-row-start-center">-->
<!--<mat-icon class="icon s-24">search</mat-icon>-->
<!--<input placeholder="Search for anything" >-->
<!--</div>-->

<!--<a class="back-link" [routerLink]="'/apps/dashboards/project'">Go back to dashboard</a>-->

<!--</div>-->

<!--</div>-->

<div id="error-404" class="flex-column-center-center">
  <div class="content mb-24 mt-32 flex-column-center-center">
    <div class="error-code">404</div>

    <!--<div class="message">{{ 'ERROR_500.MESSAGE' | translate }}</div>-->

    <div class="sub-message">
      {{ "ERROR_404.SUB_MESSAGE" | translate }}
      <div *ngIf="last404URL">{{ last404URL }}</div>
    </div>

    <a class="report-link" (click)="onPageBack()">{{
      "ERROR_404.BACK_PAGE" | translate
    }}</a>
    <a class="report-link" [routerLink]="'/' + appRoutesService.dashboard">{{
      "ERROR_404.BACK_HOME_PAGE" | translate
    }}</a>
    <a class="report-link" (click)="onVisitGt2()">{{
      "ERROR_404.GT2_SITE" | translate
    }}</a>
  </div>

  <!--<div class="content mb-24 flex-column-center-center">-->
  <!--<div class="sub-message">-->
  <!--{{ 'ERROR_500.SUB_MESSAGE' | translate }}-->
  <!--</div>-->

  <!--&lt;!&ndash;<a class="back-link mt-8" (click)="onPageBack()">{{ 'ERROR_500.BACK_PAGE' | translate }}</a>&ndash;&gt;-->
  <!--<a class="report-link" (click)="onPageBack()">{{ 'ERROR_500.BACK_PAGE' | translate }}</a>-->
  <!--&lt;!&ndash;<a class="report-link" [routerLink]="'/tableau-de-bord'">{{ 'ERROR_500.REPORT_PROBLEM' | translate }}</a>&ndash;&gt;-->
  <!--</div>-->

  <div class="content-form mb-32 flex-column-center-center">
    <mat-card class="content-form-card" style="width: 100%">
      <mat-card-header
        style="margin-left: 16px !important; margin-top: 8px !important"
      >
        <mat-card-title class="title-card">{{
          "ERROR_404.CONTACT_US" | translate
        }}</mat-card-title>
        <mat-card-subtitle *ngIf="translate.currentLang === 'fr-CA'"
          >Demande de ticket :
          <a href="https://gestiontraiteur.com/demande-de-ticket/"
            >https://gestiontraiteur.com/demande-de-ticket/</a
          >
        </mat-card-subtitle>
        <mat-card-subtitle *ngIf="translate.currentLang === 'en-CA'"
          >Ticket request:
          <a href="https://gestiontraiteur.com/demande-de-ticket/"
            >https://gestiontraiteur.com/demande-de-ticket/</a
          >
        </mat-card-subtitle>
      </mat-card-header>

      <mat-card-content>
        <div [formGroup]="form" class="p-16 flex-column">
          <!--<div class="">Subject</div>-->
          <mat-card-subtitle class="mt-12">{{
            "ERROR_404.CONTACT_MESSAGE" | translate
          }}</mat-card-subtitle>
          <!-- <mat-form-field style="margin-top: 8px !important">
            <mat-label>{{ "ERROR_404.SUBJECT" | translate }}</mat-label>
            <input
              matInput
              class="contact-input"
              formControlName="subject"
              type="text"
              [(ngModel)]="subject"
              required
            />
            <mat-error *ngIf="form.controls['subject'].invalid"
              >{{ "GENERIC.INPUT_LENGTH_INVALID" | translate }}
            </mat-error>
          </mat-form-field> -->

          <!--<div class="mt-4">Message</div>-->
          <!-- <mat-form-field class="">
            <mat-label>Message</mat-label>
            <textarea
              matInput
              class="contact-input"
              rows="6"
              formControlName="message"
              type="text"
              [(ngModel)]="message"
              required
            >
            </textarea>
            <mat-error *ngIf="form.controls['message'].invalid"
              >{{ "GENERIC.INPUT_LONG_LENGTH_INVALID" | translate }}
            </mat-error>
          </mat-form-field>-->
        </div>

        <div class="mt-20 mb-20 fxFlex-100p" style="width: 100%">
          <button
            mat-raised-button
            color="accent"
            style="width: 100%"
            (click)="
              onOpenInNewTab('https://gestiontraiteur.com/demande-de-ticket/')
            "
          >
            {{ "ERROR_404.NEW_TICKET" | translate }}
          </button>
        </div>
        <!-- <div class="mr-20 flex-row-end-start">
          <button
            mat-raised-button
            color="accent"
            class=""
            [disabled]="!form.valid"
            (click)="onSendContactForm()"
          >
            {{ "GENERIC.SEND" | translate }}
          </button>
        </div> -->
        <div class="flex-row-center-center">
          <div class="mat-caption mt-8">
            Version: {{ environment.appVersion }}
          </div>
        </div>
      </mat-card-content>

      <!--<mat-card-content *ngIf="successEmail">-->
      <!--<div class="mat-body-2">Votre message a été envoyer avec succès.</div>-->
      <!--</mat-card-content>-->
    </mat-card>
  </div>
</div>
